<script>
import { BButtonGroup, BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  components: {
    BDropdown,
    BButtonGroup,
    BDropdownItem,
  },

  props: {
    size: {
      type: Number,
      default: 6
    },

    items: {
      type: Array,
      default: () => [],
    },

    id: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: 'Selecione',
    },

    width: {
      type: String,
      default: '170px',
    },

    label: {
      type: String,
      default: 'name',
    },

    tooltip: {
      type: String,
      default: 'tooltip',
    },

    selected: {
      type: String,
      required: true,
    },

    offset: {
      type: String,
      default: "0,0"
    },

    truncateAt: {
      type: String,
      default: '20',
    },

    customClass: {
      type: String,
      default: '',
    },
  },

  data () {
    return {

    };
  },

  methods: {
    selectItem (item) {
      this.$emit('select', item);
    },
  },
};
</script>

<template>
  <BDropdown
    :id="id"
    no-caret
    variant="link"
    v-if="items.length > 0"
    class="nav-action nav-profile"
    toggle-class="text-decoration-none p-0"
    menu-class="bdk-input-dropdown__dropdown"
    :offset="offset"
  >
    <template #button-content>
      <div
        class="btn btn-bulldesk btn-bulldesk-transparent"
        :class="customClass"
        :style="{'minWidth': width}"
      >
        <span v-if="selected" class="value">
          {{ selected | truncate(truncateAt) }}
        </span>
        <span v-else class="value placeholder">
          {{ placeholder | truncate(truncateAt) }}
        </span>

        <IconChevron
          :size="size"
          class="toggle-down ml-auto"
        />

        <IconChevron
        :size="size"
          class="toggle-up ml-auto"
        />
      </div>
    </template>

    <BDropdownItem
      :key="item[label]"
      v-for="item in items"
      @click.prevent="selectItem(item)"
    >
      <span
        v-text="item[label]"
      />
      <tooltip
        v-if="item[tooltip]"
        :title="item[tooltip]"
        class="progress-pipeline-option"
        triggers="hover"
        :placement="'right'"
        :boundary="'viewport'"
      >
        <i class="fa fa-info"></i>
      </tooltip>
    </BDropdownItem>
  </BDropdown>

  <span
    v-else
    :class="customClass"
    disabled="disabled"
    class="btn btn-bulldesk btn-bulldesk-transparent"
  >
    <span>
      {{ selected | truncate(truncateAt) }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .dropdown {
    .btn-bulldesk-transparent {
      @media (max-width: 1500px) {
        min-width: 170px;
      }

      @media (max-width: 1025px) {
        min-width: 145px;
      }
    }
  }

  :not(.show) {
    .toggle-up {
      display: none;
    }

    .toggle-down {
      transform: rotate(90deg);
    }
  }

  .btn-bulldesk-transparent {
    border-radius: 14px;
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 150%;
    padding: 12px 20px;
  }

  .placeholder {
    @include salesflow-text($color: $salesflow-font-gray-light);
    font-family: 'Inter';
  }

  .show {
    .toggle-up {
      display: block;
      transform: rotate(-90deg);
    }

    .toggle-down {
      display: none;
    }
  }

  .progress-pipeline-option {
    width: 0.813rem;
    height: 0.813rem;
    position: relative;
    left: 4px;
    display: grid;
    place-items: center;
    border-radius: 100%;
    background-color: $salesflow-outline-gray-medium;
  }

  .progress-pipeline-option i {
    font-size: 0.5rem;
    color: white;
  }
</style>
